var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 21.9965L9.90002 24.8965C10.3322 25.3989 10.5792 26.0341 10.6 26.6965C10.5741 27.3686 10.2888 28.0045 9.80402 28.4706C9.3192 28.9368 8.67258 29.197 8 29.1965C7.33696 29.1965 6.70108 28.9331 6.23224 28.4642C5.7634 27.9954 5.5 27.3595 5.5 26.6965C4.83696 26.6965 4.20108 26.4331 3.73224 25.9642C3.2634 25.4954 3 24.8595 3 24.1965C2.9995 23.5239 3.25969 22.8773 3.72586 22.3925C4.19203 21.9076 4.82792 21.6224 5.5 21.5965C6.16236 21.6173 6.79762 21.8643 7.30002 22.2964L10.2 19.3965",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2001 5.99628L27.7001 7.49628C28.6589 8.46919 29.1964 9.78033 29.1964 11.1463C29.1964 12.5123 28.6589 13.8233 27.7001 14.7963L27.1001 15.3963C24.3091 18.1203 20.8661 20.0828 17.1001 21.0963L12.9001 22.0963L11.5001 20.6963L10.1001 19.2963L11.2001 15.0963C12.1339 11.327 14.1091 7.89631 16.9001 5.19629L17.5001 4.49628C18.473 3.53747 19.7841 3 21.1501 3C22.5161 3 23.8272 3.53747 24.8001 4.49628L26.2001 5.99628Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeat);
export default __webpack_public_path__ + "static/media/meat.f112400feb50377d7ada849a06199a4f.svg";
export { ForwardRef as ReactComponent };